<template>
    <div>
        <el-dialog title="上传pdf" :visible.sync="dialogVisiblePDF" @close="dialogFormVisiblepdf" width="60%">
            <div>
                <div v-if="pdftype == '1'">
                    <el-button @click="chooseImg('dczm', 'dczm')">选择文件</el-button>
                    <div>
                        代偿证明:{{ dczm }}
                    </div>
                </div>
                <div v-else>
                    <el-button @click="chooseImg('dctzs', 'dctzs')">选择文件</el-button>
                    <div>
                        代偿证明书:{{ dctzs }}
                    </div>
                </div>
                <div style="margin-top: 10px;">
                    <el-button v-if="pdftype == '1'" @click="Uploadpdf1()">确 定</el-button>
                    <el-button v-else @click="Uploadpdf2()">确 定</el-button>
                    <el-button @click="dialogFormVisiblepdf">取 消</el-button>
                </div>
            </div>
        </el-dialog>
        <!--上传-->
        <Upload v-if="isupload" :isupload="isupload" :type="type" :config="config" @returnImgs="returnImgsFunc">
        </Upload>
    </div>
</template>


<script>
import OrderApi from '@/api/order.js';
import Upload from '@/components/file/Upload';
export default {
    components: {
        Upload,
    },
    data() {
        return {
            dialogVisiblePDF: true,
            config: "",
            type: [],
            /*是否打开图片选择*/
            isupload: false,
            dczm: "",
            dctzs: ""
        };
    },
    props: ['order_id', 'pdftype'],
    created() {
        // console.log(this.order_id);
    },
    methods: {
        Uploadpdf1() {
            // console.log(this.dczm,this.order_id);
            let data = {
                order_id: this.order_id,
                dczm: this.dczm,
            }
            OrderApi.updczm(data, true)
                .then(res => {
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    });
                    this.$emit('close', { openDialog: false });
                })
                .catch(error => {
                });
        },
        Uploadpdf2() {
            // console.log("dctzs",this.dctzs,this.order_id);
            let data = {
                order_id: this.order_id,
                dctzs: this.dctzs,
            }
            OrderApi.updctzs(data, true)
                .then(res => {
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    });
                    this.$emit('close', { openDialog: false });
                })
                .catch(error => {
                });
        },
        /*选择图片*/
        chooseImg(file_type, file_name) {
            this.file_name = file_name;
            this.type = file_type;
            this.isupload = true;
            this.config = {
                total: 3,
                file_type: 'pdf'
            }
        },
        /*关闭选择图片*/
        returnImgsFunc(e) {
            // console.log(e);
            this.isupload = false;
            if (e != null && e.length > 0) {
                if (this.type == 'dczm') {
                    this.dczm = e[0].file_path;
                } else if (this.type == 'dctzs') {
                    this.dctzs = e[0].file_path;
                }
            }
        },
        /*关闭弹窗*/
        dialogFormVisiblepdf() {
            this.$emit('close', { openDialog: false });
        },
    }

};
</script>

<style></style>







// WEBPACK FOOTER //
// src/views/order/order/dialog/uploadPDF.vue